import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bgType?: string;
}

export const Box = styled.div<IProps>`
  .skeleton {
    border-radius: 4px;
    background-color: ${({ $bgType }) =>
      $bgType === 'black' ? '#1A1A1A' : '#f6f6f6'};
  }

  .thum {
    // width: ${mixin.pxToVw('108')};
    width: 100%;
    height: ${mixin.pxToVw('144')};
    margin-bottom: 8px;
  }

  .text01 {
    width: 108px;
    height: 20px;
  }

  .text02 {
    width: 80px;
    height: 20px;
    margin-top: 4px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .skeleton {
      border-radius: ${mixin.pxToVw('4')};
    }

    .thum {
      margin-bottom: ${mixin.pxToVw('8')};
      border-radius: ${mixin.pxToVw('4')};
    }

    .text01 {
      width: ${mixin.pxToVw('108')};
      height: ${mixin.pxToVw('20')};
    }

    .text02 {
      width: ${mixin.pxToVw('80')};
      height: ${mixin.pxToVw('20')};
      margin-top: ${mixin.pxToVw('4')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
  }
`;
